const renewalDetailsFormatter = (data, dataKey) => {
  const renewals = {}
  renewals[dataKey] = JSON.parse(JSON.stringify(data?.items||data));
  console.log(data, "data")
  return renewals
};

  export default renewalDetailsFormatter;
  